import ajax from "@/lib/ajax";

const URLs = {
    ADD: "/xiaoyue-operation/business/add" // 新增接口
};

// 获取模块配置接口
export async function addBusiness(name) {
    const resp = await ajax.post(URLs.ADD, { business_name: name });
    return resp.business_id;
}
